<template lang="pug">
transition(@enter="enter" @leave="leave")
  .l-tutorial(
    v-if="show"
  )
    .l-tutorial__bg
    .l-tutorial__main
      .l-tutorial__main__logo
      //- .l-tutorial__main__close(@click="click")
      .l-tutorial__main__inner
        .l-tutorial__main__desc
          p.l-tutorial__main__desc__txt くりからしるべは、倶利伽羅不動寺にまつわる言い伝えや、周辺のおすすめスポット紹介するコンテンツです。
          p.l-tutorial__main__desc__txt マップ上のピンから展開する情報を参拝や散策時にお役立てください。<br>いくつかスポットを開くと・・・<br>新たな入り口が・・・
        .l-tutorial__main__illust
        a.l-tutorial__main__btn(@click="click") くりからしるべをはじめる
        p.l-tutorial__main__memo ※くりからしるべでは一部を除き、"迦" を "伽" に統一して表記しています。


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-tutorial
  pos(0,0,40)
  wh()
  flexc()
  &__bg
    pos(0,0,1)
    wh()
    background-color rgba(114,114,114,0.3)
  &__main
    position relative
    z-index 2
    background-color #f6f5f1
    border-radius 15px
    +pc()
      width 500px
      padding-top 70px
      padding-bottom 70px
    +sp()
      width 660px
      padding-top 100px
      padding-bottom 88px
    
    &__logo
      +pc()
        bg2('../../assets/images/ui-tutorial-logo.png')
        pos(100px,40px)
      +sp()
        bg2('../../assets/images/ui-tutorial-logo.png',1.5)
        pos(100px,40px)
    &__inner
      position relative
      z-index 2

    &__close
      wh(40px)
      pos()
      cursor pointer
      no_highlight()
      
      &:before,
      &:after
        content ""
        pos(0,20px)
        background-color #404040
        wh(40px,3px)
      
      &.hotoke:before,
      &.hotoke:after
        background-color #FFF

      &:before
        transform rotate(45deg)
      &:after
        transform rotate(-45deg)

      +pc()
        pos(25px,25px,10)
        transition transform 100ms
        &:hover
          transform scale(1.15)
      +sp()
        pos(30px,35px,10)
    &__desc
      margin 0 auto
      +pc()
        font-size 16px
        width 340px
        line-height 2
      +sp()
        font-size 24px
        width 514px
        line-height 2
      &__txt
        &:first-child
          margin-top 0
        +pc()
          margin-top 7px
        +sp()
          margin-top 9px
    &__illust
      +pc()
        bg2('../../assets/images/ui-tutorial-illust.png')
        margin 26px auto 0
      +sp()
        bg2('../../assets/images/ui-tutorial-illust.png',1.3)
        margin 30px auto 0
    &__btn
      display block
      cursor pointer
      background-color #404040
      color #FFF
      border-radius 15px
      margin 25px auto 0
      text-align center
      font_notosans_bold()
      +pc()
        wh(300px,45px)
        line-height 45px
        font-size 16px
        transition transform 150ms
        &:hover
          transform scale(1.05)
      +sp()
        wh(400px,60px)
        line-height 60px
        font-size 21px
    &__memo
      text-align center
      +pc()
        font-size 11px
        margin-top 30px
      +sp()
        font-size 16px
        margin-top 45px

</style>


<script>
import $ from 'jquery'
import gsap from 'gsap'
import { defineComponent, computed, reactive ,watch ,onMounted} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name:'Tutorial',

  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    const show = computed(()=>{
      return store.ui.state.tutorial.show
    })


    const enter = (el, done)=> {
      gsap.fromTo(el,
        {opacity:0},
        {opacity:1,duration:0.3,delay:0,onComplete:()=>{
          done()
        }}
      )
    }
    const leave = (el, done)=> {
      gsap.to(el,
        {opacity:0,duration:0.3,delay:0,onComplete:()=>{
          done()
        }}
      )
    }

    const click = ()=> {
      store.ui.updateTutorial()
      setTimeout(() => {
        store.ui.state.tutorial.through = false
      }, 500);
    }

    onMounted(()=>{
    })

    return{
      show,
      click,
      enter,
      leave
    }
  }
})
</script>
